(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Marquee_logo"] && !Shopify.designMode) return;
  try {
    
class MarqueeComponent extends HTMLElement {
  connectedCallback() {
    // Use setTimeout to ensure DOM is fully ready
    setTimeout(() => {
      this.init();
    }, 100);
  }

  init() {
    this.wrapper = this.querySelector('[ref="wrapper"]');
    this.content = this.querySelector('[ref="content"]');
    this.items = this.querySelector('[ref="marqueeItems[]"]');
    
    if (!this.wrapper || !this.content || !this.items) {
      console.warn('Marquee: Missing required elements');
      return;
    }
    
    // Clone the items to create seamless loop
    const clone = this.items.cloneNode(true);
    clone.removeAttribute('ref');
    this.content.appendChild(clone);
    
    // Calculate speed based on content width
    const speedFactor = parseFloat(this.dataset.speedFactor) || 25;
    const itemsWidth = this.items.offsetWidth;
    
    if (itemsWidth > 0) {
      const speed = itemsWidth / speedFactor;
      this.style.setProperty('--marquee-speed', `${speed}s`);
    }
  }
}

// Make sure custom element isn't already defined
if (!customElements.get('marquee-component')) {
  customElements.define('marquee-component', MarqueeComponent);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
